module.exports = __webpack_public_path__ + "statics/img/yhz3.072277b1.png";